import { Button, STYLE_FILL } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import { CreateConfirmationToken } from '@stripe/stripe-js';
import classNames from 'classnames';
import React, { useState } from 'react';

export interface StripeButtonProps {
    isSubmitting: boolean;
    firstName?: string;
    lastName?: string;
    email?: string;
    submitFormCb?: (token: { confirmationTokenID: string }) => void;
}

const createConfirmationToken = async (
    options: Pick<CreateConfirmationToken, 'params'>,
) => {
    const result = 'ctoken_' + JSON.stringify(options);

    return {
        error: undefined,
        confirmationToken: {
            id: result,
        },
    };
};
export const StripeButton: React.FC<StripeButtonProps> = ({
    isSubmitting,
    firstName,
    lastName,
    email,
    submitFormCb,
}: StripeButtonProps) => {
    const [isLoading, setIsLoading] = useState(isSubmitting);

    const handleSubmit = async () => {
        if (!submitFormCb) {
            return;
        }

        setIsLoading(true);

        const { confirmationToken } = await createConfirmationToken({
            params: {
                payment_method_data: {
                    billing_details: {
                        name: `${firstName} ${lastName}`,
                        email,
                    },
                },
            },
        });

        submitFormCb({
            confirmationTokenID: confirmationToken.id,
        });

        setIsLoading(false);
    };

    // TODO Consider switching to Marmalade's Button and LoadingButton:
    // https://www.marmaladedesignsystem.com/76b74a45e/p/39b980-button/b/390e08
    // https://www.marmaladedesignsystem.com/76b74a45e/v/0/p/0496c4-loading-button/b/822c66
    // Problem - LoadingButton seems to look different from the old button with isLoading=true
    return (
        <div
            className={classNames({
                'eds-align--left': true,
                'eds-align--right': false,
            })}
        >
            <Button
                onClick={handleSubmit}
                __containerClassName={classNames({
                    'modal-footer-scrollable-on-desktop': true,
                })}
                style={STYLE_FILL}
                disabled={isLoading}
                keepDisabledStyleWhileLoading={false}
                data-spec="eds-modal__primary-button"
                data-automation="eds-modal__primary-button"
                data-testid="eds-modal__primary-button"
                isLoading={isLoading}
                isFullWidth={true}
            >
                {gettext('Place order with Stripe')}
            </Button>
        </div>
    );
};
